<template>
  <b-modal
    id="assign-violation"
    title="Assign Violation"
    hide-footer
    no-close-on-backdrop
    @hidden="resetForm"
  >
    <b-form-group label="Violation Type">
      <b-form-select
        v-model="createViolationForm.violation_type"
        :options="localViolationTypes"
        value-field="id"
        text-field="name"
      />
    </b-form-group>
    <b-form-group label="Source">
      <b-form-input v-model="createViolationForm.source" />
    </b-form-group>
    <ZonesSearch
      label="Zone"
      @zone-selected="createViolationForm.zone = $event"
    />
    <ServicesSearch
      v-if="createViolationForm.zone"
      :selected-zone="createViolationForm.zone"
      @service-selected="createViolationForm.service_type = $event"
    />
    <b-form-group label="Source ID">
      <b-form-textarea v-model="createViolationForm.description" />
    </b-form-group>
    <b-button
      variant="primary"
      :disabled="!createViolationForm.description || !createViolationForm.violation_type || !createViolationForm.zone || !createViolationForm.service_type || !createViolationForm.source || creatingViolation"
      block
      @click="assignViolationHandler"
    >
      <b-spinner
        v-if="creatingViolation"
        small
      />
      <span v-else>Save</span>
    </b-button>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BFormSelect, BFormGroup, BButton, BFormTextarea, BModal, BSpinner, BFormInput,
} from 'bootstrap-vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driverStoreModule from '../../../driverStoreModule'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'
import ServicesSearch from '@/views/zones/components/ServicesSearch.vue'

export default {
  components: {
    BFormSelect,
    BFormGroup,
    BModal,
    ServicesSearch,
    BButton,
    BSpinner,
    BFormInput,
    ZonesSearch,
    BFormTextarea,
  },
  props: {
    driverId: {
      type: String,
      required: true,
    },
    violationTypes: {
      type: Array,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const userData = JSON.parse(localStorage.getItem('userData'))

    const localViolationTypes = ref(props.violationTypes || [])
    const fetchViolationTypes = async () => {
      const result = await ctx.root.$store.dispatch('drivers/fetchViolationTypes')
      const { data } = result.data
      localViolationTypes.value = data
    }
    if (props.violationTypes === undefined) {
      fetchViolationTypes()
    }
    useRegisterStoreModule('drivers', driverStoreModule)
    const createViolationForm = ref({
      source: '',
      description: '',
      zone: '',
      service_type: '',
      driver: props.driverId,
      violation_type: null,
      action_by: userData.email,
    })
    const creatingViolation = ref(false)
    const assignViolationHandler = async () => {
      try {
        creatingViolation.value = true
        await ctx.root.$store.dispatch('drivers/createDriverViolation', createViolationForm.value)
        ctx.root.$bvModal.hide('assign-violation')
        ctx.emit('violation-assigned')
        successNotification('Violation assigned successfully')
      } catch (error) {
        errorNotification('An error occured while assigning violation')
      } finally {
        creatingViolation.value = false
      }
    }

    const resetForm = () => {
      createViolationForm.value.description = ''
      createViolationForm.value.violation_type = ''
      createViolationForm.value.source = ''
    }

    return {
      creatingViolation,
      assignViolationHandler,
      localViolationTypes,
      resetForm,
      createViolationForm,
    }
  },
}
</script>
